import Checkpoint from './Checkpoint'

export type GateCompletionRule = 'all_members' | 'min_members' | 'aggregate'

export interface GateArgument {
  id: string
  challengeID: string
  checkpointID: string
  completionRule: GateCompletionRule
  requirementValue?: number
  title?: string
  description?: string
  imageUrl?: string
  videoUrl?: string
  requiredActivityId?: string
  createdAt?: Date
  checkpoint: Checkpoint
}

export default class Gate {
  readonly id: string
  readonly challengeID: string
  readonly checkpointID: string
  readonly completionRule: GateCompletionRule
  readonly requirementValue?: number
  readonly title?: string
  readonly description?: string
  readonly imageUrl?: string
  readonly videoUrl?: string
  readonly requiredActivityId?: string
  readonly createdAt?: Date
  readonly checkpoint: Checkpoint

  constructor(arg: GateArgument) {
    this.id = arg.id
    this.challengeID = arg.challengeID
    this.checkpointID = arg.checkpointID
    this.completionRule = arg.completionRule
    this.requirementValue = arg.requirementValue
    this.title = arg.title
    this.description = arg.description
    this.imageUrl = arg.imageUrl
    this.videoUrl = arg.videoUrl
    this.requiredActivityId = arg.requiredActivityId
    this.createdAt = arg.createdAt
    this.checkpoint = arg.checkpoint
  }

  static fromPG(row: any): Gate {
    const checkpoint = row.checkpoints
      ? Checkpoint.fromPG(row.checkpoints)
      : row.checkpoint
        ? Checkpoint.fromPG(row.checkpoint)
        : undefined

    if (!checkpoint) {
      throw new Error(`Gate ${row.id} is missing checkpoint data`)
    }

    return new Gate({
      id: row.id,
      challengeID: row.challenge_id,
      checkpointID: row.checkpoint_id,
      completionRule: row.completion_rule ?? 'all_members',
      requirementValue: row.requirement_value ?? undefined,
      title: row.title ?? undefined,
      description: row.description ?? undefined,
      imageUrl: row.image_url ?? undefined,
      videoUrl: row.video_url ?? undefined,
      requiredActivityId: row.required_activity_id ?? undefined,
      createdAt: row.created_at ? new Date(row.created_at) : undefined,
      checkpoint,
    })
  }

  displayTitle(): string {
    return this.title ?? 'Team Challenge'
  }

  displayDescription(): string {
    return this.description ?? this.checkpoint.description
  }

  displayCity(): string {
    return this.checkpoint.title
  }
}
